import _ from 'lodash'
import {
  validateCouponDisplay
} from '../../Dashboard/OperatingDashboard/CustomerInterest/CustomerInterest'

/**
 * 檢查 batchResult 中的折價券發送結果
 * 實際發送結果是否大於0，若則更改結果為失敗
 * @param {Array} batchResult - 批次結果陣列
 * @property {Array} batchResult - 每個元素為一個陣列，包含兩個元素：
 *   - [0] 錯誤訊息（如果有）
 *   - [1] 折價券發送結果物件，包含 discountCount 屬性
 * @returns {Array} 檢查後的結果陣列
 */
export const checkResultWithDiscountCount = batchResult =>
  batchResult.map(item => {
    // 若 [0] 非 undefined，則表示有錯誤訊息，維持原樣
    if (item[0]) {
      return item
    }
    // 若 [1] 有值，則表示有折價券發送成功，必須檢查發送數是否大於0
    if (item[1] && item[1].discountCount && item[1].discountCount > 0) {
      return item
    }
    return [{
      message: '無可發送之對象，買家可能已經完成結帳',
      params: item[1] ? item[1] : {}
    }]
  })

/**
 * merge abandonedCartsData (fields quantity & yesterdayQuantity by listingId) into listingsData
 * also filter out using validateCouponDisplay function
 * @param {array} abandonedCartsData
 * @param {array} listingsData
 * @param {boolean} isAbandonedCart 是否對象為「截至昨日購物未結帳」
 */
export const mergeAbandonedDataIntoListings = (abandonedCartsData, listingsData, isAbandonedCart) =>
  listingsData
    .map(listing => {
      const { id: listingId } = listing
      const abandonedCart = _.find(abandonedCartsData, { listingId })
      const { quantity, yesterdayQuantity } = abandonedCart || {}
      const quantityField = isAbandonedCart ? 'quantity' : 'yesterdayQuantity'
      return {
        ...listing,
        quantity: quantity || 0,
        yesterdayQuantity: yesterdayQuantity || 0,
        ...validateCouponDisplay(abandonedCart, listing, quantityField)
          ? {}
          : { REMOVE_NOT_VALID: true }
      }
    })
    .filter(listing => !listing.REMOVE_NOT_VALID)

/**
 * 根據指定的 IDs 順序排序物件陣列
 * 不在 IDs 列表中的物件將會被排在最後
 * @param {Array<Object>} data 原始物件陣列。每個物件必須有一個 'id' 屬性
 * @param {Array<number>} ids 指定的 ID 排序順序陣列
 * @returns {Array<Object>} 根據 IDs 順序排序後的物件陣列
 */
export const orderByIds = (data, ids) => {
  // 將 ids 陣列中的所有元素都轉換為數字，以確保型別統一
  const numericIds = ids.map(id => Number(id))

  return _.sortBy(data, (item) => {
    const index = numericIds.indexOf(Number(item.id))
    // 如果 item.id 不在 ids 陣列中，將其視為 Infinity 以排在最後
    return index === -1 ? Infinity : index
  })
}
